const COUNTRY_LANGUAGES = {
    'Default': { nativeLanguages: ['English'] },
    'SaudiArabia': { nativeLanguages: ['Arabic'] },
    'Egypt': { nativeLanguages: ['Arabic'] },
    'Iraq': { nativeLanguages: ['Arabic'] },
    'UAE': { nativeLanguages: ['Arabic'] },
    'Jordan': { nativeLanguages: ['Arabic'] },
    'Syria': { nativeLanguages: ['Arabic'] },
    'Lebanon': { nativeLanguages: ['Arabic'] },
    'Morocco': { nativeLanguages: ['Arabic'] },
    'Bulgaria': { nativeLanguages: ['Bulgarian'] },
    'China': { nativeLanguages: ['Chinese (Simplified)'] },
    'Singapore': { nativeLanguages: ['Chinese (Simplified)'] },
    'Taiwan': { nativeLanguages: ['Chinese (Traditional)'] },
    'HongKong': { nativeLanguages: ['Chinese (Traditional)'] },
    'Macau': { nativeLanguages: ['Chinese (Traditional)'] },
    'CzechRepublic': { nativeLanguages: ['Czech'] },
    'Denmark': { nativeLanguages: ['Danish'] },
    'Netherlands': { nativeLanguages: ['Dutch'] },
    'Belgium': { nativeLanguages: ['Dutch', 'French'] },
    'Suriname': { nativeLanguages: ['Dutch'] },
    'UnitedStates': { nativeLanguages: ['English (American)'] },
    'UnitedKingdom': { nativeLanguages: ['English (British)'] },
    'Estonia': { nativeLanguages: ['Estonian'] },
    'Finland': { nativeLanguages: ['Finnish', 'Swedish'] },
    'France': { nativeLanguages: ['French'] },
    'Switzerland': { nativeLanguages: ['French', 'German', 'Italian'] },
    'Canada': { nativeLanguages: ['French', 'English'] },
    'Germany': { nativeLanguages: ['German'] },
    'Austria': { nativeLanguages: ['German'] },
    'Liechtenstein': { nativeLanguages: ['German'] },
    'Greece': { nativeLanguages: ['Greek'] },
    'Cyprus': { nativeLanguages: ['Greek', 'Turkish'] },
    'Hungary': { nativeLanguages: ['Hungarian'] },
    'Indonesia': { nativeLanguages: ['Indonesian'] },
    'Italy': { nativeLanguages: ['Italian'] },
    'Japan': { nativeLanguages: ['Japanese'] },
    'SouthKorea': { nativeLanguages: ['Korean'] },
    'NorthKorea': { nativeLanguages: ['Korean'] },
    'Latvia': { nativeLanguages: ['Latvian'] },
    'Lithuania': { nativeLanguages: ['Lithuanian'] },
    'Norway': { nativeLanguages: ['Norwegian (Bokmål)'] },
    'Poland': { nativeLanguages: ['Polish'] },
    'Portugal': { nativeLanguages: ['Portuguese'] },
    'Brazil': { nativeLanguages: ['Portuguese (Brazilian)'] },
    'Romania': { nativeLanguages: ['Romanian'] },
    'Moldova': { nativeLanguages: ['Romanian'] },
    'Russia': { nativeLanguages: ['Russian'] },
    'Belarus': { nativeLanguages: ['Russian'] },
    'Kazakhstan': { nativeLanguages: ['Russian'] },
    'Kyrgyzstan': { nativeLanguages: ['Russian'] },
    'Slovakia': { nativeLanguages: ['Slovak'] },
    'Slovenia': { nativeLanguages: ['Slovenian'] },
    'Spain': { nativeLanguages: ['Spanish'] },
    'Mexico': { nativeLanguages: ['Spanish'] },
    'Argentina': { nativeLanguages: ['Spanish'] },
    'Colombia': { nativeLanguages: ['Spanish'] },
    'Sweden': { nativeLanguages: ['Swedish'] },
    'Turkey': { nativeLanguages: ['Turkish'] },
    'Ukraine': { nativeLanguages: ['Ukrainian'] },
    'India': { nativeLanguages: ['Hindi', 'English'] }
  };
  
  export default COUNTRY_LANGUAGES;
